import { CircularProgress, styled } from "@mui/material";
import { primary } from "./colors";

export const ShardLoading = styled(CircularProgress)`
    color: ${primary}
`;